import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_campaign_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  project_hdr_guid: fromDatatype.GuidDataFieldInterface;
  project_line_guid: fromDatatype.GuidDataFieldInterface;
  project_ext_guid: fromDatatype.GuidDataFieldInterface;
  template_message_guid: fromDatatype.GuidDataFieldInterface;
  schedule_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_guid: fromDatatype.GuidDataFieldInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ref_project_id: fromDatatype.VarcharDatatypeInterface;
  ref_segment_id: fromDatatype.VarcharDatatypeInterface;
  ref_campaign_id: fromDatatype.VarcharDatatypeInterface;
  ref_treatment_id: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  processed_count: fromDatatype.IntegerDatatypeInterface;
  not_sent_count: fromDatatype.IntegerDatatypeInterface;
  sent_count: fromDatatype.IntegerDatatypeInterface;
  delivered_count: fromDatatype.IntegerDatatypeInterface;
  read_count: fromDatatype.IntegerDatatypeInterface;
  replied_count: fromDatatype.IntegerDatatypeInterface;
}

export class bl_dgmkt_campaign_hdr_RowClass
  implements bl_dgmkt_campaign_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  project_hdr_guid: fromDatatype.GuidDataFieldInterface;
  project_line_guid: fromDatatype.GuidDataFieldInterface;
  project_ext_guid: fromDatatype.GuidDataFieldInterface;
  template_message_guid: fromDatatype.GuidDataFieldInterface;
  schedule_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_guid: fromDatatype.GuidDataFieldInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ref_project_id: fromDatatype.VarcharDatatypeInterface;
  ref_segment_id: fromDatatype.VarcharDatatypeInterface;
  ref_campaign_id: fromDatatype.VarcharDatatypeInterface;
  ref_treatment_id: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  processed_count: fromDatatype.IntegerDatatypeInterface;
  not_sent_count: fromDatatype.IntegerDatatypeInterface;
  sent_count: fromDatatype.IntegerDatatypeInterface;
  delivered_count: fromDatatype.IntegerDatatypeInterface;
  read_count: fromDatatype.IntegerDatatypeInterface;
  replied_count: fromDatatype.IntegerDatatypeInterface;
}
